export function getAccountInfo(){
	const storedOauth = window.localStorage.getItem('asStudio-google-cm-account')
	const json = storedOauth ? JSON.parse( storedOauth) : undefined;
	return json
}
export function setAccountInfo(json: any){
	window.localStorage.setItem('asStudio-google-cm-account', JSON.stringify(json))
	return json
}